import React from 'react';

interface AnomalyFlagProps {
  type: 'cuf_drop' | 'zero_generation' | 'flatline';
  className?: string;
}

export const AnomalyFlag: React.FC<AnomalyFlagProps> = ({ type, className = '' }) => {
  const getAnomalyConfig = () => {
    switch (type) {
      case 'zero_generation':
        return {
          icon: '🔴',
          label: 'Zero Generation',
          bgColor: 'bg-red-100',
          textColor: 'text-red-800',
          borderColor: 'border-red-300'
        };
      case 'cuf_drop':
        return {
          icon: '⚠️',
          label: 'CUF Drop',
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          borderColor: 'border-yellow-300'
        };
      case 'flatline':
        return {
          icon: '📉',
          label: 'Flatline',
          bgColor: 'bg-orange-100',
          textColor: 'text-orange-800',
          borderColor: 'border-orange-300'
        };
      default:
        return {
          icon: '❓',
          label: 'Unknown',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          borderColor: 'border-gray-300'
        };
    }
  };

  const config = getAnomalyConfig();

  return (
    <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${config.bgColor} ${config.textColor} ${config.borderColor} ${className}`}>
      <span className="mr-1">{config.icon}</span>
      {config.label}
    </div>
  );
};